import styled from "styled-components";

import designSystemColors from "../../../styles";

export const LimitWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 1rem 2rem;
  gap: 0.5rem;
`;

export const TotalText = styled.span`
  color: ${designSystemColors.grayChart};
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
`;

export const LimitText = styled.span`
  color: ${designSystemColors.textDescription};
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
`;
